
import * as type from '../types/lists'

export const retrieveClientLists = payload => {
    return{
        type: type.REQUEST_LISTS_CONTENT,
        payload: payload
    }
}

export const resetClientLists = () => {
    return{
        type: type.RESET_LISTS_CONTENT
    }
}

export const changeListsModal = payload => {
    return{
        type: type.CHANGE_LISTS_MODALS,
        modal: payload
    }
}

export const setActiveListId = payload => {
    return{
        type: type.SET_ACTIVE_LIST_ID,
        id: payload.id
    }
}

export const resetActiveListId = payload => {
    return{
        type: type.RESET_ACTIVE_LIST_ID
    }
}

export const requestDeleteList = payload => {
    return{
        type: type.REQUEST_DELETE_LIST,
        details: payload
    }
}

export const resetDeleteList = () => {
    return{
        type: type.RESET_DELETE_LIST
    }
}

export const setActiveListDisplay = payload => {
    return{
        type: type.SET_ACTIVE_LIST_DISPLAY,
        details: payload
    }
}

export const resetActiveListDisplay = () => {
    return{
        type: type.RESET_ACTIVE_LIST_DISPLAY
    }
}

export const requestUpdateList = payload => {
    return{
        type: type.REQUEST_UPDATE_LIST,
        details: payload
    }
}

export const resetUpdateList = () => {
    return{
        type: type.RESET_UPDATE_LIST
    }
}

export const appendDeletionArray = payload => {
    return{
        type: type.APPEND_LISTS_DELETION_ARRAY,
        id: payload
    }
}

export const subtractDeletionArray = payload => {
    return{
        type: type.SUBTRACT_LISTS_DELETION_ARRAY,
        id: payload
    }
}

export const requestDeleteListArray = payload => {
    return{
        type: type.REQUEST_DELETE_LIST_ARRAY,
        details: payload
    }
}

export const resetDeleteListArray = () => {
    return{
        type: type.RESET_DELETE_LIST_ARRAY
    }
}